import {GET_USER_ACTIVITY_LOGS, GET_USER_DETAILS, GET_USERS, USER_ERROR} from "../../actions/types";

const initials = {
    data: null,
    error: null,
    total: 0,
};
const getUsersReducer = (state = initials, action) => {
    switch (action.type) {
        case GET_USERS:
            // Handle both paginated and non-paginated responses
            const isPaginated = action.payload && action.payload.content !== undefined;
            return {
                ...state,
                data: isPaginated ? action.payload : action.payload,
                error: null,
                total: isPaginated ? action.payload.totalElements : (action.payload?.length ?? 0),
            }
        case GET_USER_DETAILS:
            return {
                ...state,
                user: action.payload,
                error: null,
            }
        case GET_USER_ACTIVITY_LOGS:
            return {
                ...state,
                logs: action.payload,
                error: null,
            }
        case USER_ERROR:
            return {
                ...state,
                error: action.payload,
            }
        default:
            return state;
    }
}
export default getUsersReducer;